/**
 * Home Form Disclosure and Attestation Wrapper
 * Wraps the shared DisclosureAndAttestation component with home-specific configuration
 */

import SharedDisclosureAndAttestation from 'views/shared/DisclosureAndAttestation';
import FormInput from 'components/fields/home/FormInput';
import { SECTIONS } from 'views/home_form/constants';
import useIsBinderDisabled from 'hooks/useFormBinderDisabled';

const DisclosureAndAttestation = () => {
  const isDisabled = useIsBinderDisabled('homePersonalForm');

  return (
    <SharedDisclosureAndAttestation
      formStateKey="homePersonalForm"
      section={SECTIONS.DISCLOSURE_AND_ATTESTATION}
      FormInput={FormInput}
      isLocked={isDisabled}
    />
  );
};

export default DisclosureAndAttestation;
